import React, { useRef } from "react";
import "./GotMobile.scss";
import MobileContent from "./Mobile_content";
import { useMediaQueriesContext } from "@Src/hooks";
import { Button, Modal, FlyoutFullScreen, Icon } from "@accessdev/arc-ui-react";
import PropTypes from "prop-types";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

function GotMobile({ buttonClassType = "primary-outlined" }) {
  const mediaQueries = useMediaQueriesContext();

  const triggerRef = useRef(null);
  const [isOpen, setIsOpen] = React.useState(false);

  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
    triggerRef.current.focus();
  };

  return (
    <>
      <div className="Footer-btnContainer">
        <Button
          ref={triggerRef}
          onClick={openModal}
          displayStyle={buttonClassType}
          type="button"
          className="Footer-btn"
          additionalProps={{ "aria-label": t`Get the mobile app` }}
        >
          <Trans>Get the App</Trans>
        </Button>
      </div>

      {isOpen && (
        <React.Fragment>
          {mediaQueries.forTabletUp ? (
            <Modal onClose={closeModal} className="GotMobile-modal" defaultPadding={false}>
              <MobileContent />
            </Modal>
          ) : (
            <FlyoutFullScreen
              defaultPadding={false}
              isOpen={isOpen}
              onClose={closeModal}
              variant="flyout gotMobile_flyout"
            >
              <div>
                <Icon type="button" icon="close" className="close" onClick={closeModal} />
              </div>
              <MobileContent closeModal={closeModal} />
            </FlyoutFullScreen>
          )}
        </React.Fragment>
      )}
    </>
  );
}

GotMobile.propTypes = {
  buttonClassType: PropTypes.string,
};

export default GotMobile;
